import type { ComponentProps, Dispatch, SetStateAction } from 'react';

import { hasValue } from 'utils/hasValue';

import type { PayoutRequestErrors } from 'api';

import { DetailsItem } from '@atoms/DetailsItem/DetailsItem';

import { ErrorBadge } from './ErrorBadge';
import { getAttributeErrors } from './get-attribute-errors';
import type { PAYOUTS_KNOWN_SECTIONS } from './PayoutDetails';

type Props = ComponentProps<typeof DetailsItem> & {
  section?: string;
  attrName?: string;
  errors?: PayoutRequestErrors;
  activeSection?: PAYOUTS_KNOWN_SECTIONS;
  setActiveSection?: Dispatch<SetStateAction<PAYOUTS_KNOWN_SECTIONS>>;
};

export const ErrorableDetailsItem = ({
  section,
  attrName,
  errors,
  activeSection,
  setActiveSection,
  ...props
}: Props) => {
  const attributeErrorsCanBeCalculated =
    hasValue(errors) && hasValue(section) && hasValue(attrName);

  const attributeErrors = attributeErrorsCanBeCalculated
    ? getAttributeErrors(errors, section, attrName)
    : null;

  const shouldShowAttributeErrors =
    hasValue(attributeErrors) &&
    hasValue(activeSection) &&
    hasValue(setActiveSection) &&
    attributeErrors.length > 0;

  if (attrName === 'iban') {
    return (
      <div className="flex flex-col gap-6">
        {shouldShowAttributeErrors && (
          <ErrorBadge
            attributeErrors={attributeErrors}
            activeSection={activeSection}
            setActiveSection={setActiveSection}
          />
        )}
        <DetailsItem {...props} />
      </div>
    );
  }

  return shouldShowAttributeErrors ? (
    <ErrorBadge
      attributeErrors={attributeErrors}
      activeSection={activeSection}
      setActiveSection={setActiveSection}
    />
  ) : (
    <DetailsItem {...props} />
  );
};
